import BudgetManagement from '@/api/resources/budgetManagement';

const state = {
  budgetManagements: [],
};

const getters = {
  getBudgetManagements: ($state) => $state.budgetManagements,
};

const actions = {
  fetchBudgetManagements({ commit }, payload) {
    BudgetManagement.index(payload).then((response) => {
      commit('setBudgetManagements', response);
    });
  },

  validateBudgetManagement({ dispatch }, payload) {
    dispatch('initLoading');

    return BudgetManagement.validateOffer(payload).then((response) => response).finally(() => {
      dispatch('removeLoading');
    });
  },
};

const mutations = {
  setBudgetManagements($state, payload) {
    const stateCopy = $state;
    stateCopy.budgetManagements = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
